import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Client } from '../../client-data/client.model';
import { UnmatchedTransaction } from './unmatched-transaction.model';

export const UNMATCHED_PAYMENTS_WITH_CLIENTS_SCHEMA = Object.freeze({
  CLIENTS: List<Client>([]),
  UNMATCHED_TRANSACTIONS: List<UnmatchedTransaction>([]),
});
const RECORD = generateSchema(UNMATCHED_PAYMENTS_WITH_CLIENTS_SCHEMA);
const KEYS: any = generateKeys(UNMATCHED_PAYMENTS_WITH_CLIENTS_SCHEMA);

export class UnmatchedPaymentsWithClients extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CLIENTS,
        value: props.get(KEYS.CLIENTS)
          ? this.clients.map((client) => new Client(client)).toList()
          : null,
      },
      {
        key: KEYS.UNMATCHED_TRANSACTIONS,
        value: props.get(KEYS.UNMATCHED_TRANSACTIONS)
          ? this.unmatchedTransactions
              .map((transaction) => new UnmatchedTransaction(transaction))
              .toList()
          : null,
      },
    ]);

    return selfModel as UnmatchedPaymentsWithClients;
  }

  get clients(): List<Client> {
    return this.get(KEYS.CLIENTS);
  }

  get unmatchedTransactions(): List<UnmatchedTransaction> {
    return this.get(KEYS.UNMATCHED_TRANSACTIONS);
  }
}
